// extracted by mini-css-extract-plugin
export default {"defaultStyle":"bimPriceLevel_defaultStyle__Gn0nq"};